'use client';

import WarrantyPage from '@/components/organisms/warranty-page';
import React from 'react';

const WarrantyPageTastic = ({data}: any) => {
    const warrantyPageData = data.data.dataSource;
    return <WarrantyPage WarrantyPageData={warrantyPageData} />
};

export default WarrantyPageTastic;